import React, { useState } from "react";
import { UpdateUser } from "../../../../Redux/Slices/User";
import hidePwdImg from "../../../../asset/new/icons/hide_passwd_icon.svg";
import showPwdImg from "../../../../asset/new/icons/show_passwd.svg";

const PasswordReset = () => {
  const [newPass, setNewPass] = useState("");
  const [confirmPass, setConfirmPass] = useState("");
  const [isRevealPwd, setIsRevealPwd] = useState(false);
  const [isRevealPwd2, setIsRevealPwd2] = useState(false);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    const id = localStorage.getItem("id");
    if (!newPass || !confirmPass) {
      setError("Please fill both password fields");
      return;
    }
    if (newPass !== confirmPass) {
      setError("Passwords don't match");
      return;
    }
    setSaving(true);
    setError("");
    try {
      await UpdateUser(id, { password: newPass });
      setNewPass("");
      setConfirmPass("");
    } finally {
      setSaving(false);
    }
  };

  return (
    <form className="jsp-form" onSubmit={handlePasswordReset}>
      {error && <p className="jsp-error">{error}</p>}

      <div className="jsp-input-wrap">
        <input
          value={newPass}
          onChange={(e) => setNewPass(e.target.value)}
          type={isRevealPwd ? "text" : "password"}
          className="jsp-input"
          placeholder="New password"
          autoComplete="new-password"
        />
        <img
          className="jsp-input-toggle"
          title={isRevealPwd ? "Hide password" : "Show password"}
          alt=""
          src={isRevealPwd ? hidePwdImg : showPwdImg}
          onClick={() => setIsRevealPwd((prev) => !prev)}
        />
      </div>

      <div className="jsp-input-wrap">
        <input
          value={confirmPass}
          onChange={(e) => setConfirmPass(e.target.value)}
          type={isRevealPwd2 ? "text" : "password"}
          className="jsp-input"
          placeholder="Confirm password"
          autoComplete="new-password"
        />
        <img
          className="jsp-input-toggle"
          title={isRevealPwd2 ? "Hide password" : "Show password"}
          alt=""
          src={isRevealPwd2 ? hidePwdImg : showPwdImg}
          onClick={() => setIsRevealPwd2((prev) => !prev)}
        />
      </div>

      <button
        type="submit"
        className="jsp-btn jsp-btn-primary"
        disabled={saving}
        style={{ alignSelf: "flex-start" }}
      >
        {saving ? "Updating..." : "Update Password"}
      </button>
    </form>
  );
};

export default PasswordReset;
